import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
// import { Route } from 'react-router-dom';

import { Field, FieldArray, Form } from 'formik';
import { get, upperFirst } from 'lodash-es';
// import { get, isObject, startCase, upperFirst } from 'lodash-es';

// import BasicTopbar from '../../components/BasicTopbar';
import { Button } from '../../components/common';
import { CompanyName, ResourceSelect } from '../../components/formik';
import FeatureTypes from '../../utils/FeatureTypes';
import SavviLoading from '../../components/SavviLoading';
import { OutsideFormFinalizeReviewModal } from '../../components/FinalizeReviewModal/FinalizeReviewModal';
import { getOutsideBoxToken } from '../../redux/modules/Cabinet/operations';
import useInterval from '../../utils/useInterval';
import usePageFocused from '../../utils/usePageFocused';
import LoadingModal from '../../components/LoadingModal/LoadingModal';
import { TooltipAction } from '../../components/common/Tooltip/Tooltip';

function parseCodedDescription(codedDescription) {
  const match = codedDescription.match(/\[metadata ([^\]]+)\]/);
  let parsedData = {};
  if (match) {
    match[1].split('&').forEach(pair => {
      const [key, value] = pair.split('=');
      parsedData[key] = value;
    });
  }
  const cleanDescription = codedDescription.replace(/\[metadata [^\]]+\]/, '').trim();
  return { cleanDescription, parsedData };
}

const OutsideForm = ({
  error,
  formValidationErrors,
  handleDelete,
  handleFinalize,
  handleFormBlur,
  handleResourceName,
  // handleSetResourceIds,
  history,
  isFetching,
  isFetchingInit,
  isFinalized,
  isReviewModalOpen,
  // values = {},
  params,
  questionnaireMeta,
  questions,
  reviewInfo,
  toggleReviewModal,
  ...props
}) => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const { room_access_code, access_code } = params || {};
  const { name, description, state } = questionnaireMeta || {};
  const { cleanDescription, parsedData } = parseCodedDescription(description || '');
  const { auto_submit, subscription_doc, submit_message } = parsedData;
  const isSomeDocQuestions = questions.some(question =>
    question.innerQuestions.some(
      innerQ => innerQ?.feature_type?.feature_type === 'document',
    ),
  );
  const isFocused = usePageFocused();
  const [isLoadingModalOpen, setIsLoadingModalOpen] = useState(false);
  const [hasLoadingModalShown, setHasLoadingModalShown] = useState(false);
  const [shouldRefreshOnFocus, setShouldRefreshOnFocus] = useState(false);
  const docRefreshTime =
    (isFetchingInit && 10000) ||
    (isSomeDocQuestions && !shouldRefreshOnFocus && 1800000) ||
    null;
  let emailInputVal = document.querySelector('input[type="email"]')?.value;
  if (!emailInputVal && !!reviewInfo) {
    Object.entries(reviewInfo).forEach(resourceGroups => {
      if (!!resourceGroups[1]) {
        Object.entries(resourceGroups[1]).forEach(resource => {
          if (!!resource[1]) {
            Object.entries(resource[1]).forEach(([fieldKey, fieldVal]) => {
              if (fieldKey.toLowerCase().includes('email')) {
                emailInputVal = fieldVal;
              }
            });
          }
        });
      }
    });
  }
  let submissionLoadingText = 'Processing Form Submission...';
  let submissionBodyTextOne = 'Feel free to ';
  let submissionBodyTextTwo =
    'for any documents, rooms or other information related to you';

  if (subscription_doc) {
    submissionBodyTextOne = `After submission review, a Subscription Agreement signature link will be emailed to you, and will be available through your Dashboard. `;
    submissionBodyTextTwo = '';
  }
  if (auto_submit) {
    submissionLoadingText =
      'Processing Form Submission to generate your Subscription Agreement, may take 10-15 seconds...';
    submissionBodyTextOne = `A Subscription Agreement signature link as been emailed to ${
      emailInputVal || 'you'
    }, or you can `;
    submissionBodyTextTwo = ' to see your Subscription Agreement and Deal Room.';
  }
  if (submit_message) {
    submissionBodyTextOne = submit_message;
  }

  const isCompleted = isFinalized || state === 'completed';
  const loadingModalOpenMS = auto_submit ? 10000 : 3000;

  useInterval(ev => {
    if (isFocused && isSomeDocQuestions && access_code) {
      dispatch(getOutsideBoxToken(access_code, true));
    } else if (!isFocused && isSomeDocQuestions && access_code) {
      setShouldRefreshOnFocus(true);
    }
  }, docRefreshTime);

  useEffect(() => {
    if (isFocused && shouldRefreshOnFocus) {
      setShouldRefreshOnFocus(false);
      dispatch(getOutsideBoxToken(access_code, true));
    }
  }, [access_code, dispatch, shouldRefreshOnFocus, isFocused]);

  useEffect(() => {
    if (!!isFinalized && !hasLoadingModalShown) {
      setIsLoadingModalOpen(true);
      setHasLoadingModalShown(true);
      setTimeout(() => {
        setIsLoadingModalOpen(false);
      }, loadingModalOpenMS);
    }
  }, [isFinalized, loadingModalOpenMS, hasLoadingModalShown]);

  return (
    <div className="outside-form__content">
      <div className={`outside-form-header${error ? ' outside-form-header--error' : ''}`}>
        <h1>
          {name || 'Onboarding Form'}
          {isCompleted && !!cleanDescription && <TooltipAction text={cleanDescription} />}
        </h1>
        {!isCompleted && <h4>{cleanDescription}</h4>}
        {!isCompleted && questions.length > 0 && (
          <h4>
            Questions marked with <span>*</span> are required.
          </h4>
        )}
      </div>
      {isCompleted && !error && (
        <div className="outside-form__loader">
          <h2>{'Form has been submitted, thank you!'}</h2>
          <h2>
            {submissionBodyTextOne}
            <Button
              buttonType="link"
              size="inherit"
              onClick={ev =>
                push({
                  pathname: '/login',
                  state: {
                    redirectPathname: '/c/0/dashboard/personal',
                    passedEmail: emailInputVal,
                  },
                })
              }
            >
              View Your Dashboard
            </Button>
            {submissionBodyTextTwo}
          </h2>
        </div>
      )}
      {!isFetchingInit && error && (
        <div className="outside-form__loader">
          <h2>{error}</h2>
          <h2>
            {submissionBodyTextOne}
            <Button
              buttonType="link"
              size="inherit"
              onClick={ev =>
                push({
                  pathname: '/login',
                  state: {
                    redirectPathname: '/c/0/dashboard/personal',
                    passedEmail: emailInputVal,
                  },
                })
              }
            >
              View Your Dashboard
            </Button>
            {submissionBodyTextTwo}
          </h2>
          {!!room_access_code && (
            <h2>
              {'Or you can '}
              <Button
                buttonType="link"
                size="inherit"
                onClick={ev => push(`/data-room/${room_access_code}/overview`)}
              >
                View Room Overview
              </Button>
              {' for info related to your submitted form.'}
            </h2>
          )}
        </div>
      )}
      {isFetchingInit && (
        <div className="outside-form__loader">
          <SavviLoading />
          <span className="workbench__loading">Loading...</span>
        </div>
      )}
      {!isCompleted && !error && questions.length > 0 && (
        <Form className="workbench-form" id="workbench__form" autoComplete="nope">
          {!!formValidationErrors.length > 0 && (
            <div className="workbench-form__errors">
              {formValidationErrors.map((err, ind) => (
                <p key={`form-validation-error-${ind}`}>{err}</p>
              ))}
            </div>
          )}
          {questions.map(question => {
            const {
              custom_label,
              innerQuestions = [],
              isCompany,
              multi_entry, // property to tell if you have multiple of that resource.
              name,
              resourceArr = [],
              resource_type_id,
              resource_label,
            } = question;
            let updatedLabel = custom_label;
            if (!(custom_label || '').includes('Name')) {
              updatedLabel = updatedLabel + ' Name';
            }
            let operatingStateInd = innerQuestions.findIndex(
              e => e.feature_type.name === 'operating_state',
            );
            let companyName = get(resourceArr, '[0].resource_name', 'Company');
            if (operatingStateInd !== -1) {
              updatedLabel = innerQuestions[operatingStateInd].question_text;
            }

            const isResourceSelectShowing =
              resource_type_id !== 6 &&
              (resource_type_id !== 2 ||
                (resource_type_id === 2 && resource_label === 'Fund Performance'));
            let resourceHeader = `${upperFirst(custom_label)} Information`;
            if (resource_type_id === 2 && resource_label !== 'Fund Performance') {
              resourceHeader = `${companyName} Information*`;
            }
            const isResourceSublabelShowing =
              (resource_type_id !== 2 ||
                (resource_type_id === 2 && resource_label === 'Fund Performance')) &&
              resource_type_id !== 16 &&
              resource_type_id !== 25 &&
              !!multi_entry;

            return (
              <FieldArray
                key={`multi-resource-${name}`}
                name={name}
                render={arrayHelpers => (
                  <div className="workbench-form__group">
                    <h3 className="form__heading">
                      {resourceHeader}
                      {isResourceSublabelShowing && (
                        <small className="form__sub-heading">
                          Enter the names of each {custom_label}:
                        </small>
                      )}
                    </h3>
                    {resourceArr.length > 0 &&
                      resourceArr?.[0].resource_name &&
                      resourceArr.map((resource, index) => (
                        <Fragment key={`resource-${resource.resource_name}`}>
                          {isResourceSelectShowing && (
                            <Field
                              autoComplete="nope"
                              component={isCompany ? CompanyName : ResourceSelect}
                              isDraftResource={resource.is_draft}
                              isEntityFormed={get(
                                resource,
                                'innerQuestions[0].isEntityFormed',
                                false,
                              )}
                              isOutsideForm
                              entityType={get(
                                resource,
                                'innerQuestions[0].entityType',
                                '',
                              )}
                              handleChangeResource={() => {}}
                              handleDelete={handleDelete}
                              handleRemoveResource={() => {}}
                              handleResourceName={name =>
                                handleResourceName(
                                  {
                                    name,
                                  },
                                  resource.resource_id,
                                )
                              }
                              icon="user"
                              isCompany={isCompany}
                              isFixed={resource.innerQuestions[0].fixed}
                              isRequired
                              questionHelp={
                                resource.innerQuestions[0].question_help ||
                                resource.innerQuestions[0].feature_type.question_help
                              }
                              sublabel={
                                resource.innerQuestions[0].question_comment ||
                                resource.innerQuestions[0].feature_type.question_comment
                              }
                              isWorkbench
                              label={updatedLabel}
                              name={`${name}[${index}].resource`}
                              onResourceSelect={() => {}}
                              params={params}
                              resourceTypeName={name}
                              resourceTypeCustomLabel={custom_label}
                              setLabel={() => {}}
                            />
                          )}
                          {resource.innerQuestions.map((innerQ, questionIndex) => {
                            if (
                              innerQ.isHidden ||
                              innerQ.feature_type.name === 'operating_state' ||
                              innerQ.feature_type.name === 'name'
                            ) {
                              return null;
                            }
                            return (
                              <Fragment
                                key={`inner-questions-${resource.resource_name}-${innerQ.name}`}
                              >
                                <Question
                                  handleFormBlur={e => {
                                    if (e.target.value !== innerQ.value) {
                                      handleFormBlur(
                                        e.target.value,
                                        innerQ.feature_type.id,
                                        innerQ.feature_id,
                                        resource.resource_id,
                                        resource_type_id,
                                      );
                                    }
                                  }}
                                  featureProps={innerQ}
                                  innerQuestions={resource.innerQuestions}
                                  params={params}
                                  resourceTypeName={name}
                                  resourceIndex={index}
                                  resource_id={resource.resource_id}
                                  resource_name={resource.resource_name}
                                />
                              </Fragment>
                            );
                          })}
                        </Fragment>
                      ))}
                  </div>
                )}
              />
            );
          })}
          {!!formValidationErrors.length > 0 && (
            <div className="workbench-form__errors">
              {formValidationErrors.map((err, ind) => (
                <p key={`form-validation-error-${ind}`}>{err}</p>
              ))}
            </div>
          )}
          <div className="outside-form__bottom">
            <div className="outside-form-buttons">
              <Button
                isFetching={isFetching || isFinalized}
                isDisabled={isFinalized}
                size="wide"
                type="submit"
              >
                Submit
              </Button>
            </div>
          </div>
        </Form>
      )}
      <div className="outside-form__help">
        <p>
          For help with any issues please contact us at{' '}
          <a href="mailto:support@savvi.legal">support@paperos.com</a>
        </p>
      </div>
      {isReviewModalOpen && (
        <OutsideFormFinalizeReviewModal
          // history={history}
          // isFetching={isFetching}
          isOutsideForm
          isOpen={isReviewModalOpen}
          handleFinalize={handleFinalize}
          onClose={() => toggleReviewModal()}
          params={params}
          reviewInfo={reviewInfo}
          // ReviewInfoComponent={ReviewInfo}
        />
      )}
      <LoadingModal isOpen={isLoadingModalOpen} loadingText={submissionLoadingText} />
    </div>
  );
};

const Question = ({
  featureProps,
  handleFormBlur,
  innerQuestions,
  params,
  resourceTypeName,
  resourceIndex,
  resource_id,
  resource_name,
}) => {
  const {
    feature_type: {
      calendly_options,
      feature_type,
      filename,
      is_creatable,
      multi_entry_feature,
      json: { markdown = '' } = {},
      options,
      path: qpath,
      question_comment: qc,
      question_help: qh,
    } = {},
    feature_type_id,
    fixed,
    json: { markdown: flattenedMarkdown = '' } = {},
    is_label,
    is_required,
    path,
    question_comment,
    question_help,
    question_label,
    question_placeholder,
    question_text,
    tags,
  } = featureProps;
  let updatedOptions = calendly_options || options;
  if (feature_type === 'detailed_options') {
    updatedOptions = JSON.parse(options);
  }
  let isRequired = !!is_required;

  if (feature_type === 'social_security') {
    const addressIndex = innerQuestions.findIndex(innerQ =>
      innerQ.feature_type.feature_type.includes('address'),
    );

    if (addressIndex !== -1) {
      const isAddressUSA = (
        innerQuestions[addressIndex]?.value?.country?.value ||
        innerQuestions[addressIndex]?.value?.country ||
        ''
      ).includes('United States of America');
      if (isAddressUSA) {
        isRequired = true;
      } else {
        isRequired = false;
      }
    }
  }
  const updatedName = `${resourceTypeName}[${resourceIndex}]${question_label}`;

  return (
    <div className="grid--flex">
      <Field
        autoComplete="nope"
        component={FeatureTypes[feature_type].Formik}
        featureProps={featureProps}
        feature_type={feature_type}
        feature_type_id={feature_type_id}
        filename={filename}
        handleFormBlur={handleFormBlur}
        isCreatable={!!is_creatable}
        isDetailedOptions={feature_type === 'detailed_options'}
        isFixed={!!fixed}
        isLabel={!!is_label}
        isOutsideForm
        isRequired={isRequired}
        label={question_text}
        markdown={markdown || flattenedMarkdown}
        multiEntry={multi_entry_feature}
        name={updatedName}
        options={updatedOptions}
        params={params}
        path={path || qpath}
        placeholder={question_placeholder}
        questionHelp={question_help || qh}
        resource_id={resource_id}
        resource_name={resource_name}
        resetValue={FeatureTypes[feature_type].value}
        setLabel={() => {}}
        sublabel={question_comment || qc}
        tags={tags}
        taskId={params.transactionId}
        validate={isRequired && FeatureTypes[feature_type].validate}
      />
    </div>
  );
};

OutsideForm.propTypes = {
  isFetching: PropTypes.bool,
  formTitle: PropTypes.string,
  status: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  values: PropTypes.object,
};

OutsideForm.defaultProps = {
  status: {},
};

export default OutsideForm;
